module.exports = __webpack_public_path__ + "img/ic_kalender.a8943dfb.svg";